import * as angular from "angular";
import {Observable} from "rxjs";
import {VisitPlanHttpService} from "../angular/services/visit-plan-http.service";
import {CommonsFacadeService} from "../../commons/angular/state/commons/commons-facade.service";
import {SchedulingProjectAlertsService} from "./scheduling-project-alerts.service";

export class VisitPlanTemplateService {

  /* @ngInject */
  constructor(
    private visitPlanHttpService: VisitPlanHttpService,
    private commonsFacadeService: CommonsFacadeService,
    private schedulingProjectAlertsService: SchedulingProjectAlertsService
  ) {
  }

  createTemplate(payload: any): Observable<any> {
    this.commonsFacadeService.setLoaderOn();

    return new Observable((observer) => {
      this.visitPlanHttpService.createTemplate(payload)
        .subscribe({
          next: (response) => {
            this.commonsFacadeService.setLoaderOff();
            this.schedulingProjectAlertsService.createTemplateSuccess();
            observer.next(response);
            observer.complete();
          },
          error: (error) => {
            this.commonsFacadeService.setLoaderOff();
            this.schedulingProjectAlertsService.createTemplateError();
            console.error(error);
            observer.error(error);
          }
        });
    });
  }

  updateTemplate(templateId: string, payload: any): Observable<any> {
    this.commonsFacadeService.setLoaderOn();

    return new Observable((observer) => {
      this.visitPlanHttpService.updateTemplate(templateId, payload)
        .subscribe({
          next: (response) => {
            this.commonsFacadeService.setLoaderOff();
            this.schedulingProjectAlertsService.updateTemplateSuccess();
            observer.next(response);
            observer.complete();
          },
          error: (error) => {
            this.commonsFacadeService.setLoaderOff();
            this.schedulingProjectAlertsService.updateTemplateError();
            console.error(error);
            observer.error(error);
          }
        });
    });
  }

  deleteTemplate(templateId: string): Observable<void> {
    this.commonsFacadeService.setLoaderOn();

    return new Observable((observer) => {
      this.visitPlanHttpService.deleteTemplate(templateId)
        .subscribe({
          next: () => {
            this.commonsFacadeService.setLoaderOff();
            this.schedulingProjectAlertsService.deleteTemplateSuccess();
            observer.next();
            observer.complete();
          },
          error: (error) => {
            this.commonsFacadeService.setLoaderOff();
            this.schedulingProjectAlertsService.deleteTemplateError();
            console.error(error);
            observer.error(error);
          }
        });
    });
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .service('visitPlanTemplateService', VisitPlanTemplateService);

